interface ShouldOpenPositionsModalArgs {
  /** Account is in Pending Approval status. */
  isPending: boolean;
  /** Admin arrived via the single-group auto-navigate (the Go To Site Permission landing). */
  isSingleGroup: boolean;
  /** Positions already assigned to the user in this group. */
  positionCount: number;
  /** Group positions are still being fetched. */
  isLoading: boolean;
}

/**
 * True when the Positions modal should auto-open on the permission view.
 *
 * The admin reaches UserPermissionView for a single-group user via the
 * "Go To Site Permission" approval flow: handleGoToPermission navigates to the
 * permission list, which auto-navigates a single-group user into the view with
 * isSingleGroup = true. When that user is still Pending Approval and holds no
 * position in the group, open the modal so a position can be assigned at once.
 * Wait for positions to finish loading so the modal opens against real options.
 */
export const shouldOpenPositionsModal = ({
  isPending,
  isSingleGroup,
  positionCount,
  isLoading,
}: ShouldOpenPositionsModalArgs): boolean =>
  isPending && isSingleGroup && positionCount === 0 && !isLoading;
